<template>
  <div>
    <v-card class="elevation-2 ml-5 mr-5 my-5 pa-3">
      <v-row dense>
        <v-col cols="12">
          <h4>Filter Transaksi</h4>
        </v-col>
      </v-row>
      <v-row dense v-if="permission.includes('Read Transactions')">
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-radio-group v-model="submissionType" row class="mt-0">
            <v-radio label="Pemasukan" value="PEMASUKAN"></v-radio>
            <v-radio label="Pengeluaran" value="PENGELUARAN"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="12" md="6" lg="4">
          <v-text-field
            type="datetime-local"
            v-model="fromDate"
            label="Dari Tanggal"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="4">
          <v-text-field
            type="datetime-local"
            v-model="toDate"
            label="Sampai Tanggal"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-btn
            color="primary"
            small
            @click="filter"
            :disabled="
              fromDate == '' || toDate == '' || toDate < fromDate ? true : false
            "
            >Cari Transaksi</v-btn
          >
          <v-btn
            style="margin-left: 10px"
            outlined
            small
            fab
            color="indigo"
            @click="reset"
          >
            <v-icon>mdi-backup-restore</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-card elevation="2" class="ml-5 mr-5 mt-5 mb-5">
      <v-data-table
        :headers="headers"
        :items="item_items"
        disable-pagination
        :hide-default-footer="true"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Daftar Transaksi</v-toolbar-title>
          </v-toolbar>
        </template>
        <template v-slot:[`item.tanggal`]="{ item }">
          {{ formatdate(item.tanggal) }}
        </template>
        <template v-slot:[`item.no`]="{ item }">
          {{
            item_items.indexOf(item) + 1 + (currentPage - 1) * pageSize + "."
          }}
        </template>
        <template v-slot:[`item.jumlah`]="{ item }">
          {{ convertCurrency(item.jumlah) }}
        </template>
        <template v-slot:[`item.category`]="{ item }">
          {{ !item.category ? "-" : item.category }}
        </template>
        <template v-slot:[`item.metode_pembayaran`]="{ item }">
          {{ !item.metode_pembayaran ? "-" : item.metode_pembayaran }}
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <v-chip
            @click="detailSubmission(item)"
            small
            class="ma-2 white--text"
            label
            :color="submissionColor[item.type]"
            ><v-icon left small>{{ submissionIcon[item.type] }}</v-icon
            >{{ item.type }}</v-chip
          >
        </template>
        <template v-slot:no-data>
          <span class="text-center">No data available.</span>
        </template>
        <template
          v-slot:footer
          v-if="fromDate != '' || toDate == '' || toDate < fromDate"
        >
          <v-divider></v-divider>
          <div style="padding: 0 5em">
            <v-row no-gutters>
              <v-col sm="12" md="12">
                <div :class="`d-flex justify-end`">
                  <h5>
                    Total:
                    <b style="color: green">{{ convertCurrency(jumTotal) }}</b>
                  </h5>
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
      </v-data-table>
      <div style="padding: 20px" class="d-flex">
        <v-col class="d-flex" cols="12" sm="1">
          <small style="margin-top: 30px">Item show</small>
        </v-col>
        <v-col class="d-flex" cols="12" sm="">
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            @change="handlePageSizeChange"
            style="font-size: 10px"
          ></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12">
          <v-pagination
            style="width: auto"
            v-model="currentPage"
            :length="totalPages"
            total-visible="10"
            next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left"
            @input="handlePageChange"
          ></v-pagination>
          <small style="margin-top: 20px"
            >{{ from }}-{{ to }} of {{ totalData }}</small
          >
        </v-col>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import forEach from "lodash/forEach";
import slice from "lodash/slice";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import itemTemplate from "@/components/ItemTemplate.vue";
import { formatCurrency } from "@/libs/number";
import moment from "moment";
export default {
  data: () => ({
    itemTemplate,
    dialog: false,
    expand: false,
    role: "",
    permission: [],
    showError: false,
    headers: [
      {
        text: "No.",
        align: "left",
        value: "no",
      },
      { text: "Nama Submission", value: "name" },
      { text: "Jumlah", value: "jumlah" },
      { text: "Tanggal", value: "tanggal" },
      {
        text: "Wallet",
        align: "left",
        value: "metode_pembayaran",
      },
      { text: "Kategori Submission", align: "center", value: "category" },
      { text: "Tipe Submission", value: "type" },
    ],
    item_items: [],
    default_items: [],
    item: "",
    submissionColor: {
      PEMASUKAN: "green",
      PENGELUARAN: "red",
      UNDEFINED: "primary",
    },
    submissionIcon: {
      PEMASUKAN: "call_received",
      PENGELUARAN: "call_made",
      UNDEFINED: "loop",
    },
    pageSizes: [10, 50, 100],
    currentPage: 1,
    totalPages: 0,
    pageSize: 10,
    from: 0,
    to: 0,
    totalData: 0,
    submissionType: "PEMASUKAN",
    fromDate: "",
    toDate: "",
    now: "",
    jumTotal: 0,
  }),

  computed: {
    ...mapGetters({
      dataItems: "products/getItems",
    }),

    formTitle() {
      return this.editedIndex === -1 ? "Buat Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    formatdate(value) {
      return moment(value).format("DD-MM-YYYY HH:mm:ss");
    },
    ...mapActions({
      dataProducts: "products/getProducts",
      createProducts: "products/createProducts",
      updateProducts: "products/updateProducts",
      deleteProducts: "products/deleteProducts",
      getUserById: "user/getUserById",
      getTransactionByCompanyId: "transaction/getTransactionByCompanyId",
    }),
    async filter() {
      this.now = "";
      this.item_items = [];
      this.currentPage = 1;
      this.pageSize = 10;

      const paginate = {
        page: this.currentPage,
        jum: this.pageSize,
        type: this.permission.includes("Read Transactions")
          ? this.submissionType
          : null,
        date_from: this.fromDate,
        date_to: this.toDate,
      };

      const dataTransactions = await this.getTransactionByCompanyId(paginate);
      this.jumTotal = dataTransactions.data.jumlah;
      this.totalPages = dataTransactions.data.attributes.last_page;
      this.currentPage = dataTransactions.data.attributes.current_page;
      this.from = dataTransactions.data.attributes.from;
      this.to = dataTransactions.data.attributes.to;
      this.totalData = dataTransactions.data.attributes.total;
      forEach(dataTransactions.data.attributes.data, (data) => {
        data.jumlah = Number(data.jumlah);
        data.type = data.submission_id == 0 ? "UNDEFINED" : data.type;
        this.default_items.push(data);
        this.item_items.push(data);
      });
    },
    convertCurrency(total) {
      return "Rp. " + formatCurrency(total);
    },
    async initialize() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      today = yyyy + "-" + mm + "-" + dd;
      this.now = today;

      const userLogin = JSON.parse(window.localStorage.getItem("user_data"));
      this.role = userLogin.roles[0].name;
      this.permission = userLogin.permissions;
      const paginate = {
        page: this.currentPage,
        jum: this.pageSize,
        now: this.now,
        type: this.permission.includes("Read Transactions")
          ? this.submissionType
          : null,
      };
      const dataTransactions = await this.getTransactionByCompanyId(paginate);

      this.jumTotal = dataTransactions.data.jumlah;
      this.totalPages = dataTransactions.data.attributes.last_page;
      this.currentPage = dataTransactions.data.attributes.current_page;
      this.from = dataTransactions.data.attributes.from;
      this.to = dataTransactions.data.attributes.to;
      this.totalData = dataTransactions.data.attributes.total;
      forEach(dataTransactions.data.attributes.data, (data) => {
        data.jumlah = Number(data.jumlah);
        data.type = data.submission_id == 0 ? "UNDEFINED" : data.type;
        this.default_items.push(data);
        this.item_items.push(data);
      });
    },
    async handlePageChange(value) {
      this.item_items = [];
      this.currentPage = value;
      const paginate = {
        page: this.currentPage,
        jum: this.pageSize,
        type: this.permission.includes("Read Transactions")
          ? this.submissionType
          : null,
      };

      if (this.fromDate && this.toDate) {
        paginate.date_from = this.fromDate;
        paginate.date_to = this.toDate;
      }

      if (this.now) {
        paginate.now = this.now;
      }

      const dataTransactions = await this.getTransactionByCompanyId(paginate);
      // console.log(dataTransactions)
      this.totalPages = dataTransactions.data.attributes.last_page;
      this.currentPage = dataTransactions.data.attributes.current_page;
      this.from = dataTransactions.data.attributes.from;
      this.to = dataTransactions.data.attributes.to;
      this.totalData = dataTransactions.data.attributes.total;
      forEach(dataTransactions.data.attributes.data, (data) => {
        data.jumlah = Number(data.jumlah);
        this.default_items.push(data);
        this.item_items.push(data);
      });
    },
    async handlePageSizeChange(size) {
      this.item_items = [];
      this.pageSize = size;
      this.currentPage = 1;
      const paginate = {
        page: this.currentPage,
        jum: this.pageSize,
        type: this.permission.includes("Read Transactions")
          ? this.submissionType
          : null,
      };

      if (this.fromDate && this.toDate) {
        paginate.date_from = this.fromDate;
        paginate.date_to = this.toDate;
      }

      if (this.now) {
        paginate.now = this.now;
      }

      const dataTransactions = await this.getTransactionByCompanyId(paginate);
      // console.log(dataTransactions)
      this.totalPages = dataTransactions.data.attributes.last_page;
      this.currentPage = dataTransactions.data.attributes.current_page;
      this.from = dataTransactions.data.attributes.from;
      this.to = dataTransactions.data.attributes.to;
      this.totalData = dataTransactions.data.attributes.total;
      forEach(dataTransactions.data.attributes.data, (data) => {
        data.jumlah = Number(data.jumlah);
        this.default_items.push(data);
        this.item_items.push(data);
      });
    },
    itemSelected(item) {
      this.editedItem.name = item.item_name;
      this.editedItem.harga_jual = item.harga_jual;
      this.editedItem.harga_beli = item.harga_beli;
      // console.log('Selected', this.selected)
      // console.log('Selected item', item)
      // this.items[i].item_id = item.item_id.id
      // console.log('item', item)
      // console.log('this.items', this.items)
    },

    setLabel(item) {
      return item.item_name;
    },

    inputChange(text) {
      this.item_items = this.default_items;
      if (text != "") {
        this.item_items = this.item_items.filter((item) =>
          item.item_name.toLowerCase().includes(text.toLowerCase())
        );
        this.editedItem.name = text;
      }
    },

    editItem(data) {
      this.selected = find(this.item_items, ["item_name", data.name]);
      if (this.selected == undefined) {
        this.selected = {
          id: 0,
          item_name: data.name,
          qty: 0,
          submission_id: 0,
          product_id: 0,
          user_id: data.user_id,
          company_id: data.company_id,
          created_at: "",
          updated_at: "",
          harga_jual: data.harga_jual,
          harga_beli: data.harga_beli,
        };
        this.item_items.push(this.selected);
      }
      // this.selected = data.name
      // console.log('Selected', this.selected)
      // console.log('this.item_items', this.item_items)
      // console.log('data', data)
      // forEach(data.items, item => {
      //   item.harga_jual = Number(item.harga_jual)
      //   item.harga_jual = Number(item.harga_jual)
      // })
      // this.items = data.items
      this.editedIndex = this.item_products.indexOf(data);
      this.editedItem = Object.assign({}, data);
      this.dialog = true;
      // console.log('this.item_items', this.item_items)
    },

    // async deleteItem(item) {
    //   const index = this.item_products.indexOf(item);
    //   if(confirm("Apakah anda yakin menghapus item ini?")){
    //      await this.deleteProducts(item.id)
    //      this.item_products.splice(index, 1);
    //   }
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async save() {
      if (this.editedIndex > -1) {
        try {
          // console.log(this.editedItem, 'this.editedItem')
          const response = await this.updateProducts(this.editedItem);
          response.data.attributes[0].harga_beli = Number(
            response.data.attributes[0].harga_beli
          );
          response.data.attributes[0].harga_jual = Number(
            response.data.attributes[0].harga_jual
          );
          Object.assign(
            this.item_products[this.editedIndex],
            response.data.attributes[0]
          );
        } catch (e) {
          console.log(e);
        }
      } else {
        // console.log('this.selected', this.selected)
        const response = await this.createProducts(this.editedItem);
        response.data.attributes.harga_beli = Number(
          response.data.attributes.harga_beli
        );
        response.data.attributes.harga_jual = Number(
          response.data.attributes.harga_jual
        );
        this.item_products.splice(0, 0, response.data.attributes);
      }
      this.close();
    },

    detailSubmission(item) {
      if (item.type == "PEMASUKAN") {
        this.$router.push(
          "/pemasukan?id=" + item.submission_id + "&category=" + item.category
        );
      } else if (item.type == "PENGELUARAN") {
        this.$router.push(
          "/pengeluaran?id=" + item.submission_id + "&category=" + item.category
        );
      }
    },
    async reset() {
      this.now = "";
      this.toDate = "";
      this.fromDate = "";
      this.item_items = [];
      this.currentPage = 1;
      this.pageSize = 10;
      this.submissionType = "PEMASUKAN";

      const paginate = {
        page: this.currentPage,
        jum: this.pageSize,
        type: this.permission.includes("Read Transactions")
          ? this.submissionType
          : null,
      };

      const dataTransactions = await this.getTransactionByCompanyId(paginate);
      this.jumTotal = dataTransactions.data.jumlah;
      this.totalPages = dataTransactions.data.attributes.last_page;
      this.currentPage = dataTransactions.data.attributes.current_page;
      this.from = dataTransactions.data.attributes.from;
      this.to = dataTransactions.data.attributes.to;
      this.totalData = dataTransactions.data.attributes.total;
      forEach(dataTransactions.data.attributes.data, (data) => {
        data.jumlah = Number(data.jumlah);
        data.type = data.submission_id == 0 ? "UNDEFINED" : data.type;
        this.default_items.push(data);
        this.item_items.push(data);
      });
    },
  },
};
</script>
<style>
.vue-suggestion .vs__input {
  width: 100%;
  text-align: left;
  border-bottom: 1px solid black;
  max-height: 400px;
  overflow-y: auto;
  font-size: 16px;
  color: black;
  position: relative;
}
.vue-suggestion .vs__list {
  width: 100%;
  text-align: left;
  border: none;
  border-top: none;
  max-height: 400px;
  overflow-y: auto;
  border-bottom: 1px solid #023d7b;
  position: relative;
}
.vue-suggestion .vs__list .vs__list-item {
  position: relative;
  z-index: 1;
  background-color: #fff;
  padding: 10px;
  border-left: 1px solid #023d7b;
  border-right: 1px solid #023d7b;
}
.vue-suggestion .vs__list .vs__list-item:last-child {
  border-bottom: none;
}
.vue-suggestion .vs__list .vs__list-item:hover {
  background-color: #eee !important;
}
.vue-suggestion .vs__list,
.vue-suggestion .vs__loading {
  position: absolute;
}
.vue-suggestion .vs__list .vs__list-item {
  cursor: pointer;
}
.vue-suggestion .vs__list .vs__list-item.vs__item-active {
  background-color: #f3f6fa;
}
</style>